import React from "react";

import { isDefined } from "@utils/helpers";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

type Hours = {
    closingTime: string | null;
    middayClosingTime?: string | null;
    middayOpeningTime?: string | null;
    openingTime: string | null;
};

type StoreOpeningHoursComponentProps = {
    hours: Hours;
};

const StoreOpeningHoursComponent = ({
    hours,
}: StoreOpeningHoursComponentProps) => {
    const { t } = useGranite();
    const openingHours = hours
        ? [
              hours.openingTime,
              hours.middayClosingTime,
              hours.middayOpeningTime,
              hours.closingTime,
          ]
              .filter(x => x)
              .join(" - ")
        : undefined;

    const openingHoursText = isDefined(openingHours)
        ? openingHours
        : t("storePicker.storeInfo.label.closedToday");

    return <p className={"m-0"}>{openingHoursText}</p>;
};

export { StoreOpeningHoursComponent };
